import { roundMoney } from './soldBy';

// GST helpers. Product prices in this app are GST-inclusive (standard for
// Indian retail/MRP), so tax is split out of the price for display/reporting
// rather than added on top at checkout.

export const GST_RATES = [0, 5, 18, 40];

export function splitGst(inclusiveAmount, rate) {
  const taxable = rate ? inclusiveAmount / (1 + rate / 100) : inclusiveAmount;
  return { taxable, tax: inclusiveAmount - taxable };
}

// Groups bill/cart lines by GST rate, pro-rating any overall discount across
// lines first, and returns a rate-wise breakup with an even CGST/SGST split.
export function gstBreakup(lines, discount = 0, subtotal = null) {
  const total = subtotal ?? lines.reduce((sum, l) => sum + (Number(l.price) || 0) * (Number(l.qty) || 0), 0);
  const byRate = new Map();

  lines.forEach((line) => {
    const rate = line.gstRate || 0;
    const lineAmountValue = (Number(line.price) || 0) * (Number(line.qty) || 0);
    const lineDiscount = total > 0 ? (lineAmountValue / total) * discount : 0;
    const netAmount = lineAmountValue - lineDiscount;
    const entry = byRate.get(rate) || { rate, amount: 0 };
    entry.amount += netAmount;
    byRate.set(rate, entry);
  });

  return [...byRate.values()]
    .sort((a, b) => a.rate - b.rate)
    .map(({ rate, amount }) => {
      const { taxable, tax } = splitGst(amount, rate);
      const roundedTax = roundMoney(tax);
      const cgst = roundMoney(roundedTax / 2);
      return {
        rate,
        taxable: roundMoney(taxable),
        tax: roundedTax,
        cgst,
        sgst: roundMoney(roundedTax - cgst),
      };
    });
}
